import React from "react";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { coachQueryOptions } from "~/lib/query-options";
import { MainProfile } from "~/routes/$username/_profile/index";

const parentRoute = getRouteApi("/_public/discovery/$username");

export const Route = createFileRoute("/_public/discovery/$username/")({
  component: CoachProfilePage,
});

function CoachProfilePage() {
  // Get coach data from parent route
  const { coach } = parentRoute.useLoaderData();

  const { data: otherOffers = [] } = useQuery(
    coachQueryOptions.otherOffers(
      coach?.id || "",
      coach?.mainOffer?.id,
      coach?.membershipPlan,
    ),
  );

  if (!coach?.profile) {
    return <div className="p-6">Loading...</div>;
  }

  return <MainProfile coach={coach} otherOffers={otherOffers} />;
}
